import { easeOutCubic } from 'tabview/visualizations/misc/math';
import { fontFamily } from '@ardoq/design-tokens';

/* place and route parameters */

export const AQBLOCKS_NODECHANNEL_MINIMUM_SIZE = 16; // minimum grid row and col size for routing cols and rows
export const AQBLOCKS_ROUTINGCHANNEL_MINIMUM_SIZE = 16; // minimum grid row and col size for routing cols and rows
export const AQBLOCKS_ROUTING_PAD = 13; // space between non-empty routing channels and nodes
export const AQBLOCKS_ROUTING_SEP = 26; // space between routing lines
export const AQBLOCKS_ROUTING_ENDSEGMENT_SIZE = 56; // space for markers between non-empty routing channels and nodes

export const AQBLOCKS_NODE_MINIMUMSIZE: [number, number] = [160, 120];

export const AQBLOCKS_NODE_MARGIN = 0; // node margin world units (space between cell and visible bounds)

/* animations */

export const AQBLOCKS_HOVER_DELAY = 50; // ms
export const AQBLOCKS_TOOLTIP_DELAY = 1000; // ms
export const AQBLOCKS_TRANSITION_DURATION = 750;
export const AQBLOCKS_TRANSITION_TWEEN = easeOutCubic;

/* global hypercolors */

export const AQBLOCKS_FOCUS_STROKE = '#70A3F360';
export const AQBLOCKS_BACKGROUNDFILL = '#ffffff';

export const AQBLOCKS_SCROLLBAR_GUTTERFILL = '#00000020';
export const AQBLOCKS_SCROLLBAR_BARFILL = '#00000070';

export const AQBLOCKS_DROPSHADOW_FILL = '#00000020';
export const AQBLOCKS_DROPSHADOW_OFFSET = 1.5; // pixels

export const AQBLOCKS_LOWLIGHT = 0.55; // alpha (normalised) for low lighting effect
export const AQBLOCKS_TINT = 0.9; // blend (normalised) for overlays

export const AQBLOCKS_FIT_PADDING = 30; // padding (pixels) around graphically fit rectangles
export const AQBLOCKS_POINTER_SLOP = 3; // hit test slop (pixels)

/* labels and sublabels */

export const AQBLOCKS_FONT_FAMILY = fontFamily.regular;
export const AQBLOCKS_LABEL_FONTSIZE = 14; // font size (world units) for node and reference labels
export const AQBLOCKS_LABEL_LINESIZE = 16; // line stride (world units) for node and reference labels
export const AQBLOCKS_SUBLABEL_FONTSIZE = 12; // font size (world units) for node sublabels and multilabels
export const AQBLOCKS_SUBLABEL_LINESIZE = 14; // line stride (world units) for node sublabels and multilabels
export const AQBLOCKS_SUBLABEL_CORNER = 5; // sublabel border corner radius (world units)
export const AQBLOCKS_SUBLABEL_CORNERCLAMP = [2, +Infinity]; // sublabel border corner radius clamped range (pixels)
export const AQBLOCKS_SUBLABEL_BORDERCLAMP = [0.5, 2]; // sublabel border thickness clamp

/* node visual constants */

export const AQBLOCKS_CONTEXT_STROKE = '#8080ff'; // context node external border stroke color

export const AQBLOCKS_SELECT_STROKE = '#000000'; // node border stroke color

export const AQBLOCKS_PAD = 4; // space (world units) between border and internal components
export const AQBLOCKS_SEP = 2; // space (world units) between internal components

export const AQBLOCKS_CORNER = 9; // node corner radius (world units)
export const AQBLOCKS_CORNERCLAMP = [1.5, +Infinity]; // clamping range (pixels) for node corner size
export const AQBLOCKS_EXPANDER_SIZE = 16; // expander size (world units)
export const AQBLOCKS_GROUPRD_SIZE = 18; // icon height (world units) of group node "icon"
export const AQBLOCKS_LEAFRD_SIZE = 64; // height (world units) of leaf node rd
export const AQBLOCKS_LEAFRD_PAD = 4; // space (world units) between outside of the rd and actual drawing
export const AQBLOCKS_BADGE_SIZE = 16; // height (world units) of group node "badge"
export const AQBLOCKS_BORDER_SIZE = 1.5; // node border thickness (world units)
export const AQBLOCKS_BORDER_SIZECLAMP = [0.5, 2]; // clamping range (pixels) for node border
export const AQBLOCKS_SELECTBORDER_SIZE = 3; // selected node border thickness (world units)
export const AQBLOCKS_SELECTBORDER_SIZECLAMP = [2, 8]; // clamping range (pixels) for selected node border thickness

/* reference visual constants */

export const AQBLOCKS_REFERENCE_SIZE = 1.5; // thickness (world units) of reference lines
export const AQBLOCKS_REFERENCE_SIZECLAMP = [0.25, 4]; // clamping range (pixels) for thickness of reference lines
export const AQBLOCKS_REFERENCE_CORNER = 8; // reference corner radius (world units)
export const AQBLOCKS_REFERENCE_CORNERCLAMP = [1.5, 12]; // reference corner radius clamp (pixels)
export const AQBLOCKS_SELECTEDREFERENCE_SIZE = 4; // thickness (world units) of reference lines
export const AQBLOCKS_SELECTEDREFERENCE_SIZECLAMP = [2, 8]; // clamping range (pixels) for thickness of reference lines
export const AQBLOCKS_REFERENCE_MARKER_SIZE = 8; // size (world units) of reference marker
export const AQBLOCKS_REFERENCE_MARKER_SIZECLAMP = [0.5, +Infinity]; // clamping range (pixels) for reference marker size

/* interaction visual constants */

export const AQBLOCKS_HANDLE_SIZE = 6; // editing handle size (pixels)
export const AQBLOCKS_HANDLE_GRABSIZE = 9; // editing handle size (pixels)
export const AQBLOCKS_HANDLE_FILL = '#ffffff';
export const AQBLOCKS_HANDLE_STROKE = '#000000';

export const AQBLOCKS_ALIGNMENT_SIZE = 1; // thickness of editing alignment lines (pixels)
export const AQBLOCKS_ALIGNMENT_STROKE = '#AF73FF';
export const AQBLOCKS_ALIGNMENT_LINEDASH = [2, 4]; // pixels

export const AQBLOCKS_MARQUEE_STROKE = '#AF73FF';

export const AQBLOCKS_GOODDROP_ALPHA = 0.8;
export const AQBLOCKS_BADDROP_ALPHA = 0.2;
export const AQBLOCKS_BADDROP_FILL = '#ff0000';
